import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const ReCaptchaButtonAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "recaptcha-button" */ './recaptcha-button'),
  componentName: 'ReCaptchaButton',
});
